/** A record is quarantined once it has failed this many consecutive write attempts. */
export const QUARANTINE_THRESHOLD = 5;
export const QUARANTINE_REQUEUE_MS = 24 * 60 * 60 * 1000;
export const SUCCESS_REQUEUE_MS = 24 * 60 * 60 * 1000;
export const ID_CHUNK_SIZE = 1_000;

const BASE_BACKOFF_MS = 60_000;

/** Attempts before quarantine retry exponentially, capped to the caller's invocation budget. */
export function backoffMs(failureCount: number, maxBackoffMs: number): number {
  return Math.min(2 ** (failureCount - 1) * BASE_BACKOFF_MS, maxBackoffMs);
}

export function isQuarantined(failureCount: number): boolean {
  return failureCount >= QUARANTINE_THRESHOLD;
}
